require('../../modules/es.object.assign');
var path = require('../../internals/path');

module.exports = path.Object.assign;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/object/assign.js
// module id = 573
// module chunks = 0 1